import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Contract } from "@edp-components/edp-contract";
import { ICustomUrl } from "@edp-models/deep-link.model";
import { PushParameters } from "@edp-models/push.model";
import { GetContractFilters, SelectContract, SetContracts } from "@edp-store/actions/contract.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { take } from "rxjs/operators";
import { AppService } from "./app.service";
import { ContractService } from "./contract.service";
import { DeepLinkService } from "./deep-link.service";
import { OperationHistoryService } from "./operation-history.service";

@Injectable({
    providedIn: "root",
})
export class PushNotificationService {
    constructor(
        public appService: AppService,
        private store: Store<IAppState>,
        private deepLinkService: DeepLinkService,
        private router: Router,
        private contractService: ContractService,
        private readonly operationHistoryService: OperationHistoryService
    ) {}

    listenOpenedAppPush() {
          this.appService.getOpenedAppPush().subscribe(data => {
            if (data && data.burl) {
                this.receivePushAndFormatData(data);
            }
        });
    }

    public receivePushAndFormatData(data) {
        const parameters: PushParameters = this.decodeUrlAndCreateObjectParameters(data.burl);
        const goTo = parameters.GOTO.toLocaleLowerCase();
        const operation = parameters.Operation;

        if (parameters.ContractNr) {
            if (!!operation) {
                this.operationHistoryService.registerWithContract(parameters.ContractNr, operation, null, null, null, false);
            }
            
            this.contractService
                .getList()
                .pipe(take(1))
                .subscribe((contracts: Contract[]) => {
                    const contractsList = contracts.map(contract => this.contractService.createContract(contract));
                    this.store.dispatch(new SetContracts(contractsList));
                    this.store.dispatch(new GetContractFilters());
                    const currentContract = contractsList.find(contract => contract.ContractId === parameters.ContractNr);
                    this.store.dispatch(new SelectContract(currentContract));
                    this.createRedirect(goTo, currentContract);
                });
            return;
        }
        this.router.navigate([goTo]);
    }

    private decodeUrlAndCreateObjectParameters(url: string): any {
        let parameters = {};
        const decodedUrl = decodeURIComponent(atob(url));
        const stringParameters = decodedUrl.split("#");
        stringParameters.forEach(param => {
            if (param !== "") {
                const keyValuePairs = param.split(";");
                keyValuePairs.forEach(pair => {
                    const [key, value] = pair.split("=");
                    if (key && value) {
                        try {
                            parameters[key] = value;
                        } catch (error) {
                            console.error("Error parsing parameter", pair, error);
                        }
                    }
                });
            }
        });
        return parameters;
    }

    private createRedirect(redirectLink: string, contract: Contract) {
        this.deepLinkService
            .getAll()
            .pipe(take(1))
            .subscribe((links: ICustomUrl[]) => {
                const configuredLink = this.deepLinkService.getConfiguredLink(links, redirectLink);

                if (!configuredLink) {
                    this.deepLinkService.redirectToDefaultRoute();
                }

                this.deepLinkService.checkRouteTypeAndRedirect(configuredLink, contract);
            });
    }
}
